import { IFiltersLamenessTable } from 'models'

export const applyPageGroupIds = (
	filters: IFiltersLamenessTable | undefined,
	pageGroupIds?: number[],
): IFiltersLamenessTable | undefined => {
	if (!filters || !pageGroupIds?.length) return filters

	const tableIds = filters.groups?.ids ?? []
	const ids = tableIds.length
		? tableIds.filter(id => pageGroupIds.includes(id))
		: pageGroupIds

	return {
		...filters,
		groups: {
			...filters.groups,
			ids,
		},
	}
}
